import styled from "styled-components";
import { TEXT_SECONDARY } from "@streeteasy/design-system/colors";
import { Caps } from "@streeteasy/design-system/typography";

export const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
`;

export const Heading = styled(Caps).attrs({
  as: "h6"
})`
  display: inline-block;
  margin-right: 4px;
  color: ${TEXT_SECONDARY};
`;

export const TooltipWrapper = styled.span`
  position: relative;
  top: -1px;
`;
